module.exports = __webpack_public_path__ + "img/IMG-20181229-WA0006.f67d274d.jpg";